import {
    TextField } from "../../ui";
import {
  getAuthSession,
  getDeviceTypeNew,
  isNumberEmpty,
  PRINT_RESTO_KOT_NO,
  printDebugLog
} from "../../../constants/constant";
import DialogBox from "../../global/DialogBox";
import axios from "axios";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import { useState } from "react";
import { useSelector } from "react-redux";
import { handleInvoicePrint } from "../../../utilities/printUtils";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { useDeviceType } from "../../global/hooks/useDeviceType";

  
  const PrintKotDialog = ({ showDialog, setShowDialog }) => {
    const { billDetails } = useSelector((state) => state.bill);
    const storeApiUrl = useSelector((state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const storeActiveShopHash = useSelector((state) => state.setActiveShopHashReducer.activeShopHash);
    const { isMobile, isTablet } = useDeviceType(getDeviceTypeNew);
    const { snackbar, loader } = useSnpUI();
    const [kotNumber, setKotNumber] = useState("");

    const handlePrintKotByNo = async (kotNumber) => {
      if (isNumberEmpty(kotNumber)) {
        snackbar.show({ message: "Please enter Kot number", color: "warning" });
        return;
      }
      if (Number(kotNumber) === 0) {
        snackbar.show({ message: "Please enter valid Kot number (i.e. 1 to ....)", color: "warning" });
        return;
      }

      try {
        loader.show();
        setShowDialog(false);
        const url =
          storeApiUrl.BACKEND_BASE_URL +
          PRINT_RESTO_KOT_NO +
          "/" +
          getAuthSession().apiToken +
          "/" +
          billDetails.billNo +
          "/" +
          storeActiveShopHash.id +
          "/" +
          kotNumber;
        const response = await axios.get(url);
        loader.hide();
        if (response.data !== "" && !response.data.includes("Error@")) {
          handleInvoicePrint({
            printRef: response.data,
            name: "kot_previous",
            apiToken: getAuthSession().apiToken,
            shopId: storeActiveShopHash.id,
            billNo: billDetails.billNo,
            backendBaseUrl: storeApiUrl.BACKEND_BASE_URL,
            printOptions: { isMobile: isMobile || isTablet, silentChannel: "kot_previous", silentData: { kotNo: Number(kotNumber) } },
          });
        } else if (response.data !== "" && response.data.includes("Error@")) {
          snackbar.show({ message: response.data, color: "red" });
        }
      } catch (error) {
        loader.hide();
        printDebugLog("error : ", error);
      }
    };

    const dialogActions = () => {
      return (
        <>
          <SnpButton variant="contained" color="primary" onClick={() => handlePrintKotByNo(kotNumber)}>
            Print
          </SnpButton>
          <DismissButton
            variant="contained"
            color="primary"
            onClick={() => {
              setShowDialog(false);
              setKotNumber("");
            }}
          >
            Dismiss
          </DismissButton>
        </>
      );
    };

    const buildKotEnterData = () => {
  
      return (
        <TextField
          id="kotNumber"
          name="kotNumber"
          type="number"
          variant="filled"
          size="small"
          label={`Enter Valid KOT No (1 to ${billDetails.kotNo})`}
          value={kotNumber}
          onChange={(e) => setKotNumber(e.target.value)}
          style={{ width: "100%" }}
        />
      );
    };

    return (
      <DialogBox
        showDialog={showDialog}
        title="Print Kot By No"
        onClose={() => setShowDialog(false)}
        dialogContent={buildKotEnterData()}
        dialogActions={dialogActions()}
      />
    );
  };

  export default PrintKotDialog;
